// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22872":"5d08706c81161f58523a","55328":"3a1aac75c5878fccf135","99816":"b4b41e97b44835ec9d72"}[chunkId] + ".css";
};